import React from "react";
import styles from "./style.module.scss";

interface IProps {
  onClick: () => void;
  disabled?: boolean;
  text: string;
  btnType: "primary" | "secondary" | "sendMessage" | "sweepMessage";
  width?: string;
  marginTop?: string;

  marginRight?: string;

  marginBottom?: string;

  icon?: any;

  color?: string;
}

const Button = ({
  onClick,
  disabled,
  text,
  btnType,
  width,
  marginTop,
  marginRight,
  marginBottom,
  icon,
  color,
}: IProps) => {
  return (
    <button
      className={
        styles.ososBtn +
        " " +
        styles[btnType] +
        " " +
        `${disabled && styles.disabled}`
      }
      style={{
        width: width,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
      }}
      disabled={disabled}
      onClick={onClick}>
      <span style={{ color: color }}>
        {text}
        {icon && <img src={icon} alt="icon" />}
      </span>
    </button>
  );
};

export default Button;
